import { actionTypes } from 'actions/exercise/actionTypes';

const initState = {
  listdataExercise: {},
  loadList: false,
  dataDetailEx: {},
  dataCreate: null,
  exerciseEdited: null,
  loadCreate: false,
  deleteExercise: null,

  loadBrikloExerciseList: false,
  brikloExercise: {},
};

export default (state: any = initState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.CLEAR_LIST_EXERCISE:
      return {
        ...state,
        listdataExercise: {},
        brikloExercise: {}
      }
    case actionTypes.GET_BRIKLO_LIST_EXERCISE:
      return {
        ...state,
        loadBrikloExerciseList: true
      };
    case actionTypes.GET_BRIKLO_LIST_EXERCISE_SUCCESS:
      return {
        ...state,
        brikloExercise: payload,
        loadBrikloExerciseList: false,
        dataCreate: null,
      };
    case actionTypes.GET_BRIKLO_LIST_EXERCISE_FAIL:
      return {
        ...state,
        loadBrikloExerciseList: false
      };
    case actionTypes.GET_LIST_EXERCISE:
      return {
        ...state,
        loadList: true
      };
    case actionTypes.GET_LIST_EXERCISE_SUCCESS:
      return {
        ...state,
        listdataExercise: payload,
        loadList: false,
        dataCreate: null,
      };
    case actionTypes.GET_LIST_EXERCISE_FAIL:
      return {
        ...state,
        loadList: false
      };
    case actionTypes.GET_DETAIL_EXERCISE_SUCCESS:
      return {
        ...state,
        dataDetailEx: payload,
      };
    case actionTypes.CREATE_EXERCISE:
      return {
        ...state,
        loadCreate: true
      };
    case actionTypes.CREATE_EXERCISE_SUCCESS:
      return {
        ...state,
        dataCreate: payload,
        loadCreate: false
      };
    case actionTypes.CREATE_EXERCISE_FAIL:
      return {
        ...state,
        loadCreate: false
      };
    case actionTypes.DELETE_EXERCISE_SUCCESS:
      return {
        ...state,
        deleteExercise: payload
      };
    case actionTypes.DELETE_IMAGE_EXERCISE_SUCCESS:
      return {
        ...state,
        deleteImageExercise: payload
      };
    case actionTypes.UPDATE_EXERCISE_SUCCESS:
      return {
        ...state,
        exerciseEdited: payload,
        loadCreate: false,
      }
    default:
      return state;
  }
};
